<template>
  <div class="header">
    <div class="header-wrapper">
      <!-- <Image
        imageUrl="logo_levante_big_green.svg"
        altText="Logo Estrella Levante"
        class="logo-levante"
        :api="false"
      /> -->
      <Image
        imageUrl="logo_barmanager_black.svg"
        altText="Logo BarManager"
        class="logo-barmanager"
        :api="false"
      />
      <Languages v-if="codeLangs.length > 1"/>
    </div>
  </div>
</template>

<script>
import Image from '@/components/Image.vue'
import Languages from '@/components/Languages.vue'
import { mapState } from 'vuex'

export default {
  name: 'Header',
  components: {
    Image,
    Languages
  },
  computed: {
    ...mapState(['codeLangs'])
  }
}
</script>

<style>
.header {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  position: fixed;
  top: 0px;
  left: 0px;
  --tw-shadow-color: 0, 0, 0;
  --tw-shadow: 0 10px 15px -3px rgba(var(--tw-shadow-color), 0.1), 0 4px 6px -2px rgba(var(--tw-shadow-color), 0.05);
  -webkit-box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  width: 100%;
  z-index: 9;
}
.header-wrapper {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
}
.logo-levante {
  margin: 0px;
  width: 80px;
}
.logo-barmanager {
  margin: 0px;
  width: 120px;
}
.btn-header {
  border-radius: 0.25rem;
  cursor: pointer;
  margin-left: 0.5rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
.btn-header:hover {
  opacity: 0.9;
}
.btn-header:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.btn-header:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
</style>
